import moment from 'moment';

export const formatDate = (date, format = 'DD/MM/YYYY') => {
  if (!date) return '';
  return moment(date).format(format); // Local time by default
};

export const formatRelativeTime = (date) => {
  if (!date) return '';
  return moment(date).fromNow();
};

export default formatDate;
 